import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from '../../../components/Loader/Loader'
import ClaimNavigation from '../../../components/ClaimNavigation/ClaimNavigation'
import FormattedMessage from '../../../components/FormattedMessage/FormattedMessage'
import Response from './Response/Response'
import { claimActions } from '../../../redux/actions'

class Survey extends Component {
  componentDidMount() {
    const { tokenCode, couponCode, getSurveyByCouponCode } = this.props
    getSurveyByCouponCode(couponCode || tokenCode)
  }

  renderSurvey = surveyContent => {
    if (surveyContent) {
      return surveyContent.map(item => (
        <div className="mb-3" key={item.question}>
          {this.renderSurveyQuestion(item)}
          {this.renderSurveyAnswers(item)}
        </div>
      ))
    }
  }

  renderSurveyQuestion = item => (
    <h4 key={item.question} id={`survey-question-${item.question}`}>
      {item.question}
    </h4>
  )

  renderSurveyAnswers = item => (
    <div aria-labelledby={`survey-question-${item.question}`}>
      <Response {...item} />
    </div>
  )

  render() {
    const { survey } = this.props

    if (!survey) {
      return (
        <div>
          <Loader noBorder />
        </div>
      )
    }

    return (
      <div>
        <div className="row mb-5">
          <div className="card" style={{ width: '100%' }}>
            <div className="card-body">
              <h4>
                <FormattedMessage id="page.redemptionPage.text.surveyTitle" />
              </h4>
              <p>
                <FormattedMessage id="page.redemptionPage.text.surveyDescription" />
              </p>
              {this.renderSurvey(survey)}
            </div>
          </div>
        </div>
        <ClaimNavigation />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  survey: state.claimReducers.survey,
  couponCode: state.claimReducers.couponCode,
  tokenCode: state.claimReducers.tokenCode,
  claimStep: state.claimReducers.claimStep,
  claim: state.claimReducers,
})

const mapDispatchToProps = dispatch => ({
  getSurveyByCouponCode: (...args) => dispatch(claimActions.getSurveyByCouponCode(...args)),
  clearRedeemState: (...args) => dispatch(claimActions.clearRedeemState(...args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Survey)
